export const GOLF_PAR_VALUE = {
  EAGLE_OR_BETTER: -2,
  BIRDIE: -1,
  PAR: 0,
  BOGEY: 1
} as const

export const GOLF_PAR_COLOR = {
  NEGATIVE: '#EC407A', // Red for under par (good scores)
  POSITIVE: 'info.main', // Blue for over par (bad scores)
  NEUTRAL: 'grey.600' // Grey for par
} as const

export const GOLF_TOTAL_COLUMN = {
  BACKGROUND_COLOR_LIGHT: 'grey.200',
  BACKGROUND_COLOR_DARK: 'grey.800',
  FONT_WEIGHT: 600
} as const

export type GolfParValue = (typeof GOLF_PAR_VALUE)[keyof typeof GOLF_PAR_VALUE]
export type GolfParColor = (typeof GOLF_PAR_COLOR)[keyof typeof GOLF_PAR_COLOR]
